import style from '../CreditOnboardingEgyptLuckyV1/CreditOnboardingEgyptLuckyV1.css';
import TextField from '../../shared/TextField/TextField';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import Title from '../../shared/Typography/Title';
import SelectBox from '../../shared/SelectBox/SelectBox';
import { useState, useEffect } from 'preact/hooks';

const StepField = {
  CITY: 'city',
  DISTRICT: 'district',
  STREET: 'street',
  BUILDING_NUMBER: 'buildingNumber',
  FLOOR_AND_FLAT_NUMBER: 'floorAndFlatNumber',
};

export default function HomeAddressStep({
  onInputChange,
  onButtonClick,
  data = {},
  cities = [],
  stepNumber,
  stepCount,
}) {
  const { t } = useTranslation();
  const [districts, setDistricts] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [street, setStreet] = useState('');
  const [buildingNumber, setBuildingNumber] = useState('');
  const [floorNumber, setFloorNumber] = useState('');
  const isButtonEnabled = Object.values(StepField).every(
    field => data[field] && data[field].value && data[field].value?.trim(),
  );

  useEffect(() => {
    updateSelectedValues(data);
  }, [data, cities]);

  function updateSelectedValues(formData) {
    if (formData[StepField.CITY]) {
      const city = cities.find(
        city => city.id === formData[StepField.CITY]?.value,
      );
      setSelectedCity(city?.name ?? '');
      setDistricts(city?.districts ?? []);

      if (formData[StepField.DISTRICT]) {
        const district = city?.districts?.find(
          d => d.id === formData[StepField.DISTRICT]?.value,
        );
        setSelectedDistrict(district?.name ?? '');
      }
    }

    if (formData[StepField.STREET]) {
      setStreet(formData[StepField.STREET].value ?? '');
    }

    if (formData[StepField.BUILDING_NUMBER]) {
      setBuildingNumber(formData[StepField.BUILDING_NUMBER].value ?? '');
    }

    if (formData[StepField.FLOOR_AND_FLAT_NUMBER]) {
      setFloorNumber(formData[StepField.FLOOR_AND_FLAT_NUMBER].value ?? '');
    }
  }

  const handleCityChange = cityName => {
    const city = cities.find(city => city.name == cityName);
    onInputChange({
      target: { name: StepField.CITY, value: city?.id ?? '' },
    });

    onInputChange({
      target: { name: StepField.DISTRICT, value: '' },
    });

    setSelectedCity(city?.name);
    setDistricts(city?.districts ?? []);
    setSelectedDistrict('');
  };

  const handleDistrictChange = districtName => {
    const district = districts.find(d => d.name == districtName);
    onInputChange({
      target: { name: StepField.DISTRICT, value: district.id ?? '' },
    });
    setSelectedDistrict(districtName);
  };

  const formData = data;

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-header']}>
          <p className={style['form-header-title']}>
            {t(`STEP {step_number}/{step_count}`, {
              '{step_number}': stepNumber,
              '{step_count}': stepCount,
            })}
          </p>
        </div>
        <div className={style['form-title']}>
          <Title text={t("What's your current home address?")} />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <SelectBox
              label={t('City')}
              title={t('Select the city')}
              placeholder={t('Select')}
              name={StepField.CITY}
              closeOnChange={true}
              onChange={value => {
                handleCityChange(value);
              }}
              options={cities.map(item => item.name)}
              value={selectedCity}
            />
          </div>
          <div className={style['form-control']}>
            <SelectBox
              label={t('District')}
              title={t('Select the district')}
              placeholder={t('Select')}
              name={StepField.DISTRICT}
              closeOnChange={true}
              onChange={value => {
                handleDistrictChange(value);
              }}
              disabled={districts.length == 0}
              options={districts.map(item => item.name)}
              value={selectedDistrict}
            />
          </div>
          <div className={style['form-control']}>
            <TextField
              label={t('Street')}
              placeholder={t('E.g. Al-amal')}
              onInput={onInputChange}
              name={StepField.STREET}
              value={street}
            />
          </div>
          <div className={style['form-control']}>
            <TextField
              label={t('Building number/references')}
              placeholder={t('E.g. 18 - Black door')}
              onInput={onInputChange}
              name={StepField.BUILDING_NUMBER}
              value={buildingNumber}
            />
          </div>
          <div className={style['form-control']}>
            <TextField
              label={t('Floor and flat number')}
              placeholder={t('E.g. 23-4')}
              onInput={onInputChange}
              name={StepField.FLOOR_AND_FLAT_NUMBER}
              value={floorNumber}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth onClick={onButtonClick} disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
HomeAddressStep.Type = 'HomeAddressStep';
HomeAddressStep.EventName = 'home_address_step';
